export default function (object) {
    return Object.keys(object).map(key => object[key])
}